import { getDefaultExportFromCjs as n } from "./_commonjsHelpers.mjs";
import { _ as o } from "./_baseGet.mjs";
var u = o;
function f(e, r, a) {
  var t = e == null ? void 0 : u(e, r);
  return t === void 0 ? a : t;
}
var s = f;
const l = /* @__PURE__ */ n(s);
export {
  l as default
};
//# sourceMappingURL=get.mjs.map
